import { useMutation } from '@tanstack/react-query'
import { apiClient } from 'builder/modules/apiClient'

type Params = {
  id: number
}

export const useSkip = ({ id }: Params) => {
  const url = `/job-board/cards/${id}/skip_auto_tailoring`
  return useMutation({
    mutationFn: async () => apiClient.post(url, {}),
  })
}
